import { useAuth } from "@/hooks/useAuth";

/**
 * The organization's branding (T-1301), already on the session from /auth/me.
 *
 * One hook rather than `user?.organization?.brandPrimaryColor ?? null` at each
 * surface, so "unset means the neutral default" is decided in exactly one
 * place — a surface that receives null renders exactly what it rendered
 * before branding existed.
 */
export interface OrgBranding {
  logoUrl: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
}

export function useOrgBranding(): OrgBranding {
  const { user } = useAuth();
  const organization = user?.organization;
  return {
    logoUrl: organization?.logoUrl ?? null,
    primaryColor: organization?.brandPrimaryColor ?? null,
    secondaryColor: organization?.brandSecondaryColor ?? null,
  };
}
